import styled, { css } from "styled-components"

export const CollapsibleContainer = styled.div``
export const CollapsibleInnerContainer = styled.div`
  max-height: 0;
  overflow: hidden;
  margin-top: 0;
  ${getOverflow}
`

export const CollapsibleTitle = styled.button`
  all: unset;
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
  padding-right: ${({ theme }) => theme.spaces.normal};
  &:hover {
    cursor: pointer;
  }
`

export const CollapsibleIcon = styled.span`
  &:hover {
    cursor: pointer;
  }
`

function getOverflow({ $show, $openTime, $closeTime, theme }) {
  const space = theme.spaces.normal
  let style = css`
    transition:
      max-height ${$closeTime}s ease-out,
      margin-top ${$closeTime}s ease-out;
  `
  if ($show) {
    style = css`
      ${style}
      margin-top: ${space};
      padding-bottom: ${space};
      transition:
        margin-top ${$openTime}s ease-in,
        max-height ${$openTime}s ease-in;
    `
  }
  return style
}
